import { css, styled } from 'styled-components';

import Link from 'components/Link';

const StyledLink = styled(Link)<{ $paddingLeft?: string; $backgroundColor?: string }>`
  ${({ theme, $paddingLeft, $backgroundColor }) => css`
    height: 3.5rem;
    text-decoration: none;
    color: black;
    padding: 0.5rem 1.5rem;
    padding-left: ${$paddingLeft};
    display: flex;
    align-items: center;
    &:hover {
      background-color: ${$backgroundColor};
      color: ${theme.colors.primaryRed};
    }
    &[aria-current='page'] {
      background-color: ${$backgroundColor};
      color: ${theme.colors.primaryRed};
    }
  `}
`;

export default StyledLink;
